import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore } from "redux-persist";

import { rootReducer, rootSaga } from "./rootDuck";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))
);

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

// Auth must survive a reload as soon as login becomes visible. redux-persist
// normally stages each field on a timer, leaving a window where the dashboard
// is mounted but storage still holds the logged-out session.
let persistedAuth = store.getState().auth;
store.subscribe(() => {
    const auth = store.getState().auth;
    const changed = auth.user !== persistedAuth.user ||
        auth.authToken !== persistedAuth.authToken;
    // FLUSH dispatches another action; update the comparison before flushing.
    persistedAuth = auth;
    if (changed && auth._persist?.rehydrated) {
        // The localStorage adapter writes synchronously inside flush().
        persistor.flush();
    }
});

sagaMiddleware.run(rootSaga);   

export default store;
